module.exports = __webpack_public_path__ + "img/david-bushnell.1cf62c38.png";